import styled from 'styled-components';

import { Text } from '@dreryk/react-components';

export const StyledDate = styled(Text)`
   white-space: nowrap;
`;
StyledDate.displayName = 'StyledDate';
